import { Component, Input } from '@angular/core';
import { Context } from '../../model/context';
import { ParkourAvatarBadgeComponent } from '@parkour/ui';
import { AsyncPipe } from '@angular/common';
import { ProfielnaamPipe } from '../../pipes/profielnaam.pipe';
import { ProfielFotoPipe } from '../../pipes/profiel-foto.pipe';
import { Profiel } from '../../../profiel/model/profiel';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'parkour-profiel-indicator',
  templateUrl: './profiel-indicator.component.html',
  imports: [
    ParkourAvatarBadgeComponent,
    ProfielnaamPipe,
    ProfielFotoPipe,
    AsyncPipe,
    TranslateModule,
  ],
})
export class ProfielIndicatorComponent {
  @Input({ required: true }) userProfiel!: Profiel | undefined;
  @Input({ required: true }) context!: Context;
}
